<main role="main">
  <div class="l-main-row mobile-lg grid-container find-a-health-center find-a-health-center-min-height">
    <div class="main desktop:margin-left-15 desktop:margin-right-15">
      <div class="breadcrumb">
        <ul>
          <li>
            <a
              class="font-family-public-sans-normal font-size-rem-point875"
              rel="home"
              title="HRSA Data Warehouse"
              href="https://data.hrsa.gov"
              >Home</a
            >
          </li>
          <li>
            <i class="fa-solid fa-chevron-right"></i>&nbsp;<span
              class="font-family-public-sans-normal font-size-rem-point875"
              >{{ pageTitle }}</span
            >
          </li>
        </ul>
      </div>
      <div class="grid-row">
        <div class="grid-col-12 tablet:grid-col-8 padding-bottom-4 padding-top-3">
          <h1>{{ this.pageTitle }}</h1>
          <p class="subheader" *ngIf="subHeaderText">
            {{ subHeaderText }}
          </p>
        </div>
      </div>

      <div class="grid-row grid-gap tablet:padding-bottom-4">
        <div class="grid-col-12 tablet:grid-col-6">
          <div class="background-color-grey height-min-15 border-radius-8">
            <div class="grid-container padding-3">
              <div class="grid-row padding-bottom-3">
                <div class="grid-col-12">
                  <label for="search-field">Search by City, State, or Zip </label>
                  <div class="display-flex">
                    <input
                      aria-label="Enter a Location"
                      placeholder="Enter a Location"
                      id="search-field"
                      type="search"
                      class="usa-input custom-input maxw-full height-5 border-radius-4"
                      [(ngModel)]="nameSuggestion"
                      (ngModelChange)="handleNameSuggestion()"
                      (keydown.enter)="handleSearch()"
                    />
                    <button class="search-button" (click)="handleSearch()" aria-label="search button">
                      <i class="fa-solid fa-magnifying-glass" aria-label="search"></i>
                    </button>
                  </div>

                  <div class="search-container" [ngClass]="{ 'hide-search-options': !canShowNameSuggestions }">
                    <ul class="esri-menu__list esri-search__suggestions-list search-wrapper">
                      <li
                        (click)="handleSelectNameSuggestion(suggestionItem.text)"
                        *ngFor="let suggestionItem of nameSuggestionResults.suggestions"
                        class="search-option font-family-public-sans-normal"
                        [innerHtml]="suggestionItem.formattedText"
                      ></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="grid-row">
                <div class="grid-col-12">
                  <label for="radius-field">Radius </label>
                  <div class="usa-combo-box custom-select maxw-full">
                    <select
                      class="usa-select maxw-full margin-top-0 border-radius-4"
                      id="radius-field"
                      aria-label="Radius"
                      [(ngModel)]="selectedRadius"
                      (change)="handleRadiusChange()"
                    >
                      <option
                        *ngFor="let radiusItem of radiiForLocations"
                        [value]="radiusItem.value"
                        [attr.aria-label]="radiusItem.displayText"
                      >
                        {{ radiusItem.displayText }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col-12 tablet:grid-col-6 padding-top-4 tablet:padding-top-0">
          <hdw-resource-content></hdw-resource-content>
        </div>
      </div>
      <ng-container *ngIf="!canShowMap && displayResults && displayResults.length === 0">
        <span class="font-family-public-sans-normal"
          >There are no health centers available within the maximum radius around the search location.</span
        >
      </ng-container>
      <ng-container *ngIf="canShowMap">
        <div class="grid-row hide-on-desktop padding-bottom-2">
          <div class="grid-col-12 tablet:grid-col-6 map-height">
            <hdw-pdf-export [canShowPdfExport]="canShowPdfExport"></hdw-pdf-export>
            <hdw-map-container
              (selectedMarkerEmitter)="handleSelectedMarker($event)"
              [locationData]="locationData"
              [setFocus]="setFocus"
            ></hdw-map-container>
          </div>
        </div>
        <div class="border-top-light-grey">
          <div class="grid-row">
            <div class="grid-col-12 tablet:grid-col-6">
              <h3>Search results for {{ nameSuggestion }}</h3>
            </div>
            <div class="grid-col-12 tablet:grid-col-6">
              <div
                class="display-flex search-another-alignment flex-align-center margin-top-3 margin-bottom-3 grid-row"
              >
                <span class="display-inline-block font-family-public-sans-normal grid-col-6 tablet:grid-col-4"
                  >Search another address</span
                >
                <button
                  class="usa-button primary-button start-over-button grid-col-5 tablet:grid-col-4 padding-right-1 padding-left-1"
                  id="start-over"
                  (click)="handleStartOver()"
                >
                  <i class="fa-solid fa-arrow-rotate-left padding-right-1" aria-label="start over"></i>
                  Start Over
                </button>
              </div>
            </div>
          </div>
          <div
            class="grid-row grid-gap padding-bottom-4"
            [ngClass]="displayResults && displayResults.length ? '' : 'padding-top-4'"
          >
            <div class="grid-col-12 tablet:grid-col-6">
              <hdw-filter-by (filterByEmitter)="handleFilterBy($event)"></hdw-filter-by>
              <div class="grid-row">
                <div id="results" class="grid-col-12">
                  <div class="grid-container padding-left-0 padding-right-0">
                    <ng-container *ngFor="let result of displayResults">
                      <div
                        [ngClass]="selectedId === result.Id ? 'selected-result' : ''"
                        class="grid-row border-top-grey padding-top-2 padding-bottom-2"
                      >
                        <div class="result-circle grid-col-2" (click)="handleAddressFocus(result)">
                          {{ result.index }}
                        </div>
                        <div class="grid-col-7 tablet:grid-col-6 padding-left-2">
                          <!--Distance-->
                          <span class="font-family-public-sans-small display-block address-color"
                            >{{ result.Distance }} MILES</span
                          >
                          <!--Location Name-->
                          <span class="font-family-public-sans-bold display-block">{{ result.CtrNm }}</span>
                          <!--Operated By-->
                          <span class="font-family-public-sans-normal display-block"
                            >Operated by {{ result.ParentCtrNm }}</span
                          >
                          <!--Address Street-->
                          <span class="font-family-public-sans-normal display-block address-color">{{
                            result.CtrAddress
                          }}</span>
                          <!--Address City-->
                          <span class="font-family-public-sans-normal display-block address-color"
                            >{{ result.CtrCity }}, {{ result.CtrZipCd }}</span
                          >
                        </div>
                        <div class="tablet:grid-col-5 grid-col-12">
                          <div
                            class="grid-container padding-right-0 tablet:padding-left-2 padding-left-6 padding-top-2 tablet:padding-top-0"
                          >
                            <div class="grid-row">
                              <div class="tablet:grid-col-4 grid-col-2">
                                <ng-container *ngIf="result.UrlTxt; else website_disabled">
                                  <a [href]="result.UrlTxt" target="_blank">
                                    <div class="result-icon-item">
                                      <div class="result-icon-wrapper margin-left-rem-point25">
                                        <i class="fa-solid fa-earth-americas" aria-label="website"></i>
                                      </div>
                                      <span class="display-inline-block word-break-keep-all">Website</span>
                                    </div>
                                  </a>
                                </ng-container>
                                <ng-template #website_disabled>
                                  <div class="result-icon-item result-icon-item--disabled">
                                    <div
                                      class="result-icon-wrapper result-icon-wrapper--disabled margin-left-rem-point25"
                                    >
                                      <i class="fa-solid fa-earth-americas" aria-disabled="true" title="website"></i>
                                    </div>
                                    <span class="display-inline-block word-break-keep-all">Website</span>
                                    <div class="website-tooltip">
                                      <div class="website-tooltip-container">
                                        <span
                                          class="tooltiptext font-family-public-sans-normal margin-top-0 margin-bottom-0"
                                        >
                                          No website provided
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                              </div>

                              <div class="tablet:grid-col-4 grid-col-2 padding-left-1">
                                <a [href]="'tel:' + result.CtrPhoneNum" target="_blank">
                                  <div class="result-icon-item">
                                    <div class="result-icon-wrapper">
                                      <i class="fa-solid fa-phone" aria-label="phone"></i>
                                    </div>
                                    <span class="display-inline-block">Call</span>
                                  </div>
                                </a>
                              </div>

                              <div class="grid-col-4 padding-left-1">
                                <a [href]="result.directionsUrl" target="_blank">
                                  <div class="result-icon-item">
                                    <div class="result-icon-wrapper margin-left-rem-point75">
                                      <i class="fa-solid fa-diamond-turn-right" aria-label="directions"></i>
                                    </div>
                                    <span class="display-inline-block word-break-normal">Directions</span>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="border-top-light-grey">
                <div class="grid-row padding-top-4">
                  <div class="grid-col-12 tablet:grid-col-6">
                    <span *ngIf="totalResults" class="font-family-public-sans-normal"
                      >Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ totalResults }} results</span
                    >
                  </div>
                  <div class="grid-col-12 tablet:grid-col-6" *ngIf="locationData?.locations?.length > rows">
                    <hdw-paginator
                      [maxNumberOfPages]="4"
                      [rows]="rows"
                      [totalRecords]="totalResults"
                      (selectedIndexEmitter)="handleSelectedIndex($event)"
                      [updateSelectedIndex]="updateSelectedIndex"
                    ></hdw-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid-col-12 tablet:grid-col-6 map-height mobile:height-mobile hide-on-mobile">
              <hdw-pdf-export [canShowPdfExport]="canShowPdfExport"></hdw-pdf-export>
              <hdw-map-container
                (selectedMarkerEmitter)="handleSelectedMarker($event)"
                [locationData]="locationData"
                [setFocus]="setFocus"
              ></hdw-map-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</main>
